import { faDollarSign } from '@fortawesome/free-solid-svg-icons/faDollarSign';
import { FieldLabelIconMui5 } from 'components/atoms/FieldLabelIcon';
import {
  SelectControl,
  SelectField,
  SelectLabel,
  SelectOption,
} from 'components/atoms/Select';
import { AVAILABLE_MONTHLY_PAYMENTS } from 'shared/utils/constants';
import { getMonthlyPaymentIndex } from 'shared/utils/functions';
import {
  SetFiltersValue,
  useFilters,
} from '../../../../../services/filters/hooks/useFilters';
import { SxProps } from '@mui/system';
import { Theme as ThemeMui5 } from '@mui/material/styles/createTheme';
import { labelInputStyles } from '../styles';

const marginTopStyle: SxProps<ThemeMui5> = (t) => ({
  '&.MuiSelect-root': {
    marginTop: t.spacing(0.5),
  },
});

export const MonthlyBudgetFilter = ({
  setFiltersValue,
  disabled = false,
}: {
  setFiltersValue: SetFiltersValue;
  disabled?: boolean;
}) => {
  const { filters } = useFilters();
  return (
    <SelectControl fullWidth>
      <SelectLabel sx={labelInputStyles}>
        <FieldLabelIconMui5 icon={faDollarSign} color='primary' />
        Monthly Budget
      </SelectLabel>
      <SelectField
        variant='outlined'
        sx={marginTopStyle}
        displayEmpty
        onChange={(e) => {
          if (disabled) {
            return;
          }
          const i = e.target.value as number;
          const minMonthlyPayment = Number(AVAILABLE_MONTHLY_PAYMENTS[i]?.min);
          const maxMonthlyPayment = Number(AVAILABLE_MONTHLY_PAYMENTS[i]?.max);
          setFiltersValue({
            ...filters,
            minMonthlyPayment,
            maxMonthlyPayment,
          });
        }}
        value={getMonthlyPaymentIndex({
          minMonthlyPayment: Number(filters.minMonthlyPayment),
          maxMonthlyPayment: Number(filters.maxMonthlyPayment),
        })}
        label='Budget'
      >
        <SelectOption value='-1'>Monthly Budget</SelectOption>
        {AVAILABLE_MONTHLY_PAYMENTS.map((item, index) => (
          <SelectOption key={index} value={index}>
            {item.label}
          </SelectOption>
        ))}
      </SelectField>
    </SelectControl>
  );
};
